import React, { useState } from 'react';
import { withStyles, TextField, Typography, Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import { saleInvoiceNoteStyles as styles } from './styles';
import EditNoteModal from './EditNoteModal';

const SaleInvoiceNote = ({
    customerId,
    invoiceNote,
    setInvoiceNote,
    classes,
    defaultPlaceholder,
    showSavedNote,
    modifies,
    invoiceStatus,
    isEditingInvoice,
    onAddNote,
    onEditNote
}) => {
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editingNote, setEditingNote] = useState(null);

    const handleNoteClick = (noteType, noteId, description) => {
        if (!isEditingInvoice) return;
        setEditingNote({ noteType, noteId, description });
        setEditModalOpen(true);
    };

    const handleNoteUpdate = async ({ noteType, noteId, newDescription }) => {
        await onEditNote({ noteType, noteId, newDescription });
        setEditModalOpen(false);
        setEditingNote(null);
    };

    const clickableStyle = isEditingInvoice ? { cursor: 'pointer', textDecoration: 'underline', color: '#2b78e4' } : {};

    if (!customerId) {
        return null;
    }
    return (
        <div style={{ width: '40%' }}>
            <Typography className={classes.invoiceNotesTitle}>Invoice Notes</Typography>
            {showSavedNote && showSavedNote !== 'Invoice from POS' && (
                <Typography
                    style={{ ...clickableStyle, whiteSpace: 'pre-wrap' }}
                    onClick={() => isEditingInvoice && handleNoteClick('description', null, showSavedNote)}
                >
                    {showSavedNote}
                </Typography>
            )}
            {modifies &&
                modifies
                    .filter(note => note.description !== 'Invoice from POS')
                    .map((note, index) => (
                        <Typography
                            key={index}
                            style={{ ...clickableStyle, whiteSpace: 'pre-wrap' }}
                            onClick={() => isEditingInvoice && handleNoteClick('modify', note.id, note.description)}
                        >
                            {note.description}
                        </Typography>
                    ))}
            {invoiceStatus !== 'Paid' && (
                <>
                    <TextField
                        className={classes.noteInput}
                        variant="outlined"
                        multiline
                        rows="1"
                        disabled={invoiceStatus === 'Paid' || invoiceStatus === 'Refund' || invoiceStatus === 'Void'}
                        value={invoiceNote}
                        onChange={event => setInvoiceNote(event.target.value)}
                        placeholder={defaultPlaceholder}
                        style={{ width: '100%' }}
                    />
                    {isEditingInvoice && invoiceNote && (
                        <Button className={classes.addNoteBtn} onClick={onAddNote}>
                            Add note
                        </Button>
                    )}
                </>
            )}
            <EditNoteModal
                isOpen={editModalOpen}
                onClose={() => {
                    setEditModalOpen(false);
                    setEditingNote(null);
                }}
                onUpdate={handleNoteUpdate}
                initialValue={editingNote?.description}
                noteType={editingNote?.noteType}
                noteId={editingNote?.noteId}
            />
        </div>
    );
};

SaleInvoiceNote.propTypes = {
    customerId: PropTypes.string,
    invoiceNote: PropTypes.string,
    setInvoiceNote: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    defaultPlaceholder: PropTypes.string,
    showSavedNote: PropTypes.string,
    modifies: PropTypes.array,
    invoiceStatus: PropTypes.string,
    isEditingInvoice: PropTypes.bool,
    onAddNote: PropTypes.func,
    onEditNote: PropTypes.func
};

export default withStyles(styles)(SaleInvoiceNote);
